import { ReactElement, useEffect } from "react";

// Third parties
import { useDispatch } from "react-redux";

// Evergiving
import { FormConfig } from "@evergiving/common/dist/es2015/form";

// Redux
import { setFormSourceRef } from "@/lib/redux/actions";

// Pages
import { DonationIndexPage } from "@/lib/pages/DonationIndexPage";
import { CaptureLeadsIndexPage } from "./CaptureLeadsIndexPage";
import { useFormRouter } from "../hooks/useFormRouter";

interface IndexPageProps {
  formConfig: FormConfig;
}

export const IndexPage = ({ formConfig }: IndexPageProps): ReactElement => {
  const dispatch = useDispatch();
  const formRouter = useFormRouter();
  const formSourceRef = formRouter.getFormSourceRef();

  useEffect(() => {
    if (formSourceRef) {
      dispatch(setFormSourceRef(formSourceRef));
    }
  }, [dispatch, formSourceRef]);

  return "payment" in formConfig ? (
    <DonationIndexPage formConfig={formConfig} />
  ) : (
    <CaptureLeadsIndexPage formConfig={formConfig} />
  );
};
